import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faRightFromBracket,
  faUser,
  faFileInvoice,
  faPlus,
  faTrash,
  faDownload,
} from '@fortawesome/free-solid-svg-icons';

// 👉 Add all icons you want globally
library.add(
  faRightFromBracket,
  faUser,
  faFileInvoice,
  faPlus,
  faTrash,
  faDownload
);